import { render } from "./VabeneWebThemePage.vue?vue&type=template&id=f6fd613c&scoped=true&ts=true"
import script from "./VabeneWebThemePage.vue?vue&type=script&lang=ts"
export * from "./VabeneWebThemePage.vue?vue&type=script&lang=ts"

import "./VabeneWebThemePage.vue?vue&type=style&index=0&id=f6fd613c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6fd613c"]])

export default __exports__